import moment from "moment";

export const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const validaCpf = (cpf) => {
	var add = 0;
	var rev = 0;

	cpf = cpf.replace(/[^\d]+/g, "");

	if (cpf === "") return false;
	if (cpf.length !== 11) return false;
	if (/^(\d)\1+$/.test(cpf)) return false;

	for (var i = 0; i < 9; i++) {
		add += parseInt(cpf.charAt(i)) * (10 - i);
	}

	rev = 11 - (add % 11);
	if (rev === 10 || rev === 11) rev = 0;
	if (rev !== parseInt(cpf.charAt(9))) return false;

	add = 0;
	for (var j = 0; j < 10; j++) {
		add += parseInt(cpf.charAt(j)) * (11 - j);
	}

	rev = 11 - (add % 11);
	if (rev === 10 || rev === 11) rev = 0;
	if (rev !== parseInt(cpf.charAt(10))) return false;

	return true;
};

export const validaCnpj = (cnpj) => {
	cnpj = cnpj.replace(/[^\d]+/g, "");

	if (cnpj.length !== 14) return false;
	if (/^(\d)\1+$/.test(cnpj)) return false;

	let add = 0;
	let rev = 0;
	let pos = 5;

	for (let i = 0; i < 12; i++) {
		add += parseInt(cnpj.charAt(i)) * pos;
		pos = pos === 2 ? 9 : pos - 1;
	}

	rev = add % 11 < 2 ? 0 : 11 - (add % 11);
	if (rev !== parseInt(cnpj.charAt(12))) return false;

	add = 0;
	pos = 6;

	for (let i = 0; i < 13; i++) {
		add += parseInt(cnpj.charAt(i)) * pos;
		pos = pos === 2 ? 9 : pos - 1;
	}

	rev = add % 11 < 2 ? 0 : 11 - (add % 11);
	return rev === parseInt(cnpj.charAt(13));
};

export const verificarData = (dataInicio, dataFinal) => {
	const inicio = moment(dataInicio, "YYYY-MM-DD");
	const fim = moment(dataFinal, "YYYY-MM-DD");

	return fim.isBefore(inicio);
};

export const createFormikValidation = (formMap, values) => {
	const errors = {};

	for (let [key, value] of formMap) {
		if (!values[key] && values[key] !== 0) {
			errors[key] = "O campo " + value + " é obrigatório.";
		} else if (key.includes("email") && !regexEmail.test(values[key])) {
			errors[key] = "Você precisa informar um e-mail válido.";
		} else if ((key.includes("senha") || key.includes("password")) && values[key].length < 6) {
			errors[key] = "A senha deve ter pelo menos 6 caracteres.";
		} else if (key.includes("cep") && values[key].length < 5) {
			errors[key] = "Utilize no mínimo 8 caracteres.";
		} else if (key.includes("cpf") && !validaCpf(values[key]) && values[key].length <= 14) {
			errors[key] = "O CPF informado é inválido.";
		} else if (key.includes("cnpj") && !validaCnpj(values[key]) && values[key].length > 14) {
			errors[key] = "O CNPJ informado é inválido.";
		} else if (key.includes("telefone") && values[key].length < 14) {
			errors[key] = "Utilize no mínimo 14 caracteres.";
		} else if (key.includes("data") && /^\d{4}-\d{2}-\d{2}$/.test(values[key])) {
			const dataValidade = moment(values[key], "YYYY-MM-DD");
			if (!dataValidade.isValid()) {
				errors[key] = "A data é inválida.";
			}
		} else if (key.includes("data_nascimento") && moment(values[key]).isAfter(moment())) {
			errors[key] = "A data de nascimento não pode ser uma data futura.";
		} else if ((key.includes("dia_vencimento") || key.includes("dia_corte")) && (isNaN(values[key]) || values[key] < 1 || values[key] > 31)) {
			errors[key] = "O dia é inválido.";
		} else if (key.includes("validade") && (!moment(values[key], "MM/YY").isValid() || moment(values[key], "MM/YY").isBefore(moment()))) {
			errors[key] = "A data de validade do cartão é inválida.";
		} else if (key.includes("ano") && isNaN(values[key])) {
			errors[key] = "O ano é inválido.";
		} else if (key.includes("mes_referencia") && (isNaN(values[key]) || values[key] < 1 || values[key] > 12)) {
			errors[key] = "O mes é inválido.";
		} else if (key.includes("data_vencimento") && moment(values[key]).isBefore(moment())) {
			errors[key] = "A data de vencimento deve ser maior que a data atual.";
		}
	}

	return errors;
};
